const toggleMutisiteMenu = () => {
    const mmenuBtn = document.querySelector(".js-site-switcher-dropdown");
    const mmenuBtnMob = document.querySelector(".site-switcher__mob");
    const mmenu = document.querySelector(".main-nav-dropdown-wrap__sites-menu");
    const closemmenu = mmenu.querySelector(".site-switcher__close");
    const mmenuMob = document.querySelector(".sites-menu-mob__outer");

    if(!mmenuBtn) return false;

    if(mmenu) {
      mmenuBtn.addEventListener("click", () => {
        mmenu.classList.toggle("-open");
        document.body.classList.toggle("-site-menu-open");
      });
      if(mmenuBtnMob){
          mmenuBtnMob.addEventListener("click", () => {
              mmenuMob.classList.toggle("-open");
          });
      }
      closemmenu.addEventListener("click", () => {
        mmenu.classList.remove("-open");
        document.body.classList.remove("-site-menu-open");
      })
    }
}
toggleMutisiteMenu()
